"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractMatch = exports.isSame = void 0;
const tslib_1 = require("tslib");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const isString_1 = tslib_1.__importDefault(require("lodash/isString"));
const isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
function extractMatch(v) {
    if ((0, isString_1.default)(v) || (0, isFunction_1.default)(v))
        return v;
    return (v === null || v === void 0 ? void 0 : v.match) || 'id';
}
exports.extractMatch = extractMatch;
function isSame(el1, el2, match) {
    return (((0, isString_1.default)(match) && (0, get_1.default)(el1, match) === (0, get_1.default)(el2, match)) ||
        ((0, isFunction_1.default)(match) && match(el1, el2)));
}
exports.isSame = isSame;
